import React, { useMemo } from 'react';
import _ from 'lodash';
import './TableView.css';
import { PRIMITIVE_SCHEMAS } from '../../../utils/dtdl';
import PropTypes from 'prop-types';
import { timeToString } from '../../../utils/time';
import { useTranslation } from '../../../localization/useTranslation';
import SimpleTable, { SortDirection } from '../../Common/SimpleTable/SimpleTable';

const DefaultSortBy = {
  path: '[0]',
  direction: SortDirection.DESC
};

const TableView = ({ graphDataPackage }) => {
  const T = useTranslation();

  const [columns, rows] = useMemo(() => {
    if ((_.isEmpty(graphDataPackage) || _.isEmpty(graphDataPackage?.data))) {
      return [[], []];
    }
    // Create a list of signal and data
    const allData = _.flatMap(graphDataPackage.data, (signal) => {
      return _.map(signal.data, data => {
        let value = data[1];
        if (signal.type === PRIMITIVE_SCHEMAS.float || signal.type === PRIMITIVE_SCHEMAS.double) {
          value = Number(data[1].toFixed(signal.decimalPoint));
        }
        return {
          ...signal,
          time: data[0],
          value
        };
      });
    });
    const byTime = _.groupBy(allData, 'time');

    const rows = _.map(byTime, (timeData, time) => {
      return [timeToString(_.toInteger(time)), ..._.map(timeData, 'value')];

    });

    const columns = [
      {
        label: T.graph.dateTime,
        path: '[0]',
        isSortable: true,
        searchItem: true
      },
      ..._.map(graphDataPackage.data, ({ fullName }, index) => (
        {
          label: fullName,
          path: '[' + (index + 1) + ']',
          isSortable: true,
          searchItem: true
        }))
    ];
    return [columns, rows];
  }, [T.graph.dateTime, graphDataPackage]);

  return (
    <SimpleTable
      className="signal-table-view"
      data={rows}
      columns={columns}
      sortBy={DefaultSortBy}
      compact
    />
  );
};

TableView.propTypes = {
  graphDataPackage: PropTypes.object
};

export default TableView;
